import React from 'react';
import styled from 'types/theme.types';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { BaseItemContainer } from 'components/layout/navbar/navbar-panel.utils';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

const NavbarCollapse: React.FC = () => {
  const { isCollapsed, toggleCollapsed } = useNavbarCollapse();
  return (
    <div>
      <BaseItemContainer>
        <ToggleButton onClick={toggleCollapsed} data-e2e="navbar-collapse-toggle">
          {isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </ToggleButton>
      </BaseItemContainer>
    </div>
  );
};

const ToggleButton = styled.button`
  width: 13px;
  height: 13px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.primaryGray};
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 120ms ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.tertiaryGray};
  }

  svg {
    font-size: 14px;
  }
`;

export default NavbarCollapse;
